// Jobs data for the Jobs page — includes all domains
// Active/new jobs pulled from matchedJobs + new cross-domain listings

// Shared current project progress — single source of truth
export const currentProjectProgress = {
  jobId: 1,
  title: 'Foley & Environmental Audio',
  client: 'Confidential — Major Studio',
  domain: 'Audio',
  tier: 'Advanced',
  rate: '$46/hr',
  completed: 847,
  total: 1200,
  percent: 70.6,
  quality: 97.3,
  startDate: 'Mar 15, 2026',
  endDate: 'Apr 7, 2026',
  hoursLogged: 24,
  daysRemaining: 5,
};

// Rate ranges by tier — used for filtering and future backend integration
const RATE_RANGES = {
  Standard: { min: 38, max: 44 },
  Advanced: { min: 44, max: 48 },
  Expert: { min: 48, max: 56 },
};

export const allJobsRaw = [
  // ===== AUDIO (8 jobs) =====
  { id: 1, title: 'Foley & Environmental Audio', rate: 46, domain: 'Audio', tier: 'Advanced', client: 'Confidential — Major Studio', duration: '3–4 weeks', teamSize: 6, startDate: 'April 7, 2026', posted: '2 days ago', status: 'open', match: 97, matchReason: 'Matches your Foley specialty', instantMatch: true, hiredThisMonth: 4, referralBonus: 140 },
  { id: 2, title: 'Ambient Soundscape Classification', rate: 42, domain: 'Audio', tier: 'Standard', client: 'AI Research Lab', duration: '2 weeks', teamSize: 4, startDate: 'April 14, 2026', posted: '5 days ago', status: 'open', match: 82, matchReason: 'Based on your recent work', instantMatch: false, hiredThisMonth: 12, referralBonus: null },
  { id: 3, title: 'Speech-in-Noise Annotation', rate: 48, domain: 'Audio', tier: 'Expert', client: 'Enterprise Voice AI', duration: '4 weeks', teamSize: 8, startDate: 'April 2, 2026', posted: '1 day ago', status: 'closing_soon', match: 94, matchReason: 'High precision required', instantMatch: true, hiredThisMonth: 6, referralBonus: 200 },
  { id: 101, title: 'Podcast Transcription QA', rate: 40, domain: 'Audio', tier: 'Standard', client: 'Media Startup', duration: '2 weeks', teamSize: 3, startDate: 'April 21, 2026', posted: '3 days ago', status: 'open', match: 71, matchReason: 'Matches audio domain', instantMatch: false, hiredThisMonth: 8, referralBonus: null, needsSpecialAssessment: true },
  { id: 102, title: 'Voice Emotion Recognition', rate: 50, domain: 'Audio', tier: 'Expert', client: 'Affective Computing Lab', duration: '5 weeks', teamSize: 6, startDate: 'April 14, 2026', posted: '1 day ago', status: 'open', match: 91, matchReason: 'Emotion analysis match', instantMatch: true, hiredThisMonth: 3, referralBonus: 220 },
  { id: 103, title: 'Acoustic Event Detection', rate: 44, domain: 'Audio', tier: 'Advanced', client: 'Smart Home Co.', duration: '3 weeks', teamSize: 5, startDate: 'April 10, 2026', posted: '4 days ago', status: 'open', match: 85, matchReason: 'Matches your acoustic expertise', instantMatch: false, hiredThisMonth: 10, referralBonus: null },
  { id: 104, title: 'Music-Speech Separation Labels', rate: 38, domain: 'Audio', tier: 'Standard', client: 'Podcast Analytics', duration: '1 week', teamSize: 4, startDate: 'April 18, 2026', posted: '6 days ago', status: 'open', match: 68, matchReason: 'Audio domain match', instantMatch: false, hiredThisMonth: 15, referralBonus: null, needsSpecialAssessment: true },
  { id: 105, title: 'Spatial Audio 3D Positioning', rate: 52, domain: 'Audio', tier: 'Expert', client: 'XR Audio Startup', duration: '4 weeks', teamSize: 4, startDate: 'April 5, 2026', posted: '2 days ago', status: 'closing_soon', match: 88, matchReason: 'Spatial audio match', instantMatch: true, hiredThisMonth: 2, referralBonus: 240 },

  // ===== VIDEO (7 jobs) =====
  { id: 201, title: 'Action Recognition in Sports Footage', rate: 44, domain: 'Video', tier: 'Advanced', client: 'Sports Analytics Co.', duration: '3 weeks', teamSize: 6, startDate: 'April 10, 2026', posted: '1 day ago', status: 'open', match: 45, matchReason: 'Cross-domain opportunity', instantMatch: false, hiredThisMonth: 8, referralBonus: 140 },
  { id: 202, title: 'Autonomous Driving Scene Labeling', rate: 50, domain: 'Video', tier: 'Expert', client: 'Self-Driving AI Lab', duration: '6 weeks', teamSize: 12, startDate: 'April 7, 2026', posted: '4 days ago', status: 'open', match: 38, matchReason: 'Cross-domain opportunity', instantMatch: false, hiredThisMonth: 5, referralBonus: 300 },
  { id: 203, title: 'Video Highlight Detection', rate: 42, domain: 'Video', tier: 'Standard', client: 'Content Platform', duration: '2 weeks', teamSize: 5, startDate: 'April 14, 2026', posted: '6 days ago', status: 'open', match: 40, matchReason: 'Cross-domain opportunity', instantMatch: false, hiredThisMonth: 18, referralBonus: 120 },
  { id: 204, title: 'Surveillance Anomaly Detection', rate: 46, domain: 'Video', tier: 'Advanced', client: 'Security AI', duration: '4 weeks', teamSize: 8, startDate: 'April 12, 2026', posted: '2 days ago', status: 'open', match: 36, matchReason: 'Cross-domain opportunity', instantMatch: false, hiredThisMonth: 6, referralBonus: 160 },
  { id: 205, title: 'Gesture Recognition Annotation', rate: 44, domain: 'Video', tier: 'Advanced', client: 'AR/VR Company', duration: '3 weeks', teamSize: 6, startDate: 'April 18, 2026', posted: '1 day ago', status: 'open', match: 42, matchReason: 'Cross-domain opportunity', instantMatch: false, hiredThisMonth: 4, referralBonus: 140 },
  { id: 206, title: 'Dashcam Incident Classification', rate: 40, domain: 'Video', tier: 'Standard', client: 'Insurance Tech', duration: '2 weeks', teamSize: 10, startDate: 'April 8, 2026', posted: '3 days ago', status: 'closing_soon', match: 35, matchReason: 'Cross-domain opportunity', instantMatch: false, hiredThisMonth: 22, referralBonus: 100 },
  { id: 207, title: 'Film Shot Composition Analysis', rate: 48, domain: 'Video', tier: 'Expert', client: 'Film AI Research', duration: '5 weeks', teamSize: 5, startDate: 'April 20, 2026', posted: '1 day ago', status: 'open', match: 50, matchReason: 'Audio-visual crossover', instantMatch: false, hiredThisMonth: 2, referralBonus: 200 },

  // ===== VISUAL (7 jobs) =====
  { id: 301, title: 'Medical Image Segmentation', rate: 52, domain: 'Visual', tier: 'Expert', client: 'HealthTech Research', duration: '4 weeks', teamSize: 8, startDate: 'April 5, 2026', posted: '2 days ago', status: 'open', match: 35, matchReason: 'Cross-domain opportunity', instantMatch: false, hiredThisMonth: 4, referralBonus: 280 },
  { id: 302, title: 'E-Commerce Product Tagging', rate: 38, domain: 'Visual', tier: 'Standard', client: 'Retail Marketplace', duration: '2 weeks', teamSize: 10, startDate: 'April 12, 2026', posted: '3 days ago', status: 'open', match: 30, matchReason: 'Cross-domain opportunity', instantMatch: false, hiredThisMonth: 35, referralBonus: 80 },
  { id: 303, title: 'Satellite Imagery Classification', rate: 46, domain: 'Visual', tier: 'Advanced', client: 'GeoTech AI', duration: '3 weeks', teamSize: 6, startDate: 'April 18, 2026', posted: '1 day ago', status: 'open', match: 32, matchReason: 'Cross-domain opportunity', instantMatch: false, hiredThisMonth: 7, referralBonus: 160 },
  { id: 304, title: 'Facial Landmark Detection QA', rate: 44, domain: 'Visual', tier: 'Advanced', client: 'Beauty AI', duration: '2 weeks', teamSize: 4, startDate: 'April 10, 2026', posted: '5 days ago', status: 'open', match: 28, matchReason: 'Cross-domain opportunity', instantMatch: false, hiredThisMonth: 9, referralBonus: 120 },
  { id: 305, title: 'Document Layout Analysis', rate: 42, domain: 'Visual', tier: 'Standard', client: 'DocTech Startup', duration: '3 weeks', teamSize: 6, startDate: 'April 15, 2026', posted: '2 days ago', status: 'open', match: 33, matchReason: 'Cross-domain opportunity', instantMatch: false, hiredThisMonth: 14, referralBonus: 100 },
  { id: 306, title: 'Defect Detection in Manufacturing', rate: 50, domain: 'Visual', tier: 'Expert', client: 'Industrial AI Corp', duration: '6 weeks', teamSize: 5, startDate: 'April 8, 2026', posted: '4 days ago', status: 'closing_soon', match: 30, matchReason: 'Cross-domain opportunity', instantMatch: false, hiredThisMonth: 3, referralBonus: 260 },
  { id: 307, title: 'Wildlife Camera Trap Classification', rate: 40, domain: 'Visual', tier: 'Standard', client: 'Conservation Tech', duration: '2 weeks', teamSize: 8, startDate: 'April 22, 2026', posted: '1 day ago', status: 'open', match: 29, matchReason: 'Cross-domain opportunity', instantMatch: false, hiredThisMonth: 11, referralBonus: 100 },

  // ===== LINGUISTICS (6 jobs) =====
  { id: 401, title: 'Multilingual Sentiment Analysis', rate: 44, domain: 'Linguistics', tier: 'Advanced', client: 'Global NLP Startup', duration: '3 weeks', teamSize: 8, startDate: 'April 8, 2026', posted: '2 days ago', status: 'open', match: 42, matchReason: 'Cross-domain opportunity', instantMatch: false, hiredThisMonth: 10, referralBonus: 140 },
  { id: 402, title: 'Legal Document Entity Extraction', rate: 48, domain: 'Linguistics', tier: 'Expert', client: 'LegalTech AI', duration: '4 weeks', teamSize: 5, startDate: 'April 10, 2026', posted: '5 days ago', status: 'open', match: 38, matchReason: 'Cross-domain opportunity', instantMatch: false, hiredThisMonth: 3, referralBonus: 200 },
  { id: 403, title: 'Conversational AI Training Data', rate: 42, domain: 'Linguistics', tier: 'Standard', client: 'Chatbot Platform', duration: '2 weeks', teamSize: 12, startDate: 'April 14, 2026', posted: '3 days ago', status: 'open', match: 40, matchReason: 'Cross-domain opportunity', instantMatch: false, hiredThisMonth: 28, referralBonus: 120 },
  { id: 404, title: 'Code-Switching Detection (Hindi-English)', rate: 46, domain: 'Linguistics', tier: 'Advanced', client: 'South Asia NLP Lab', duration: '3 weeks', teamSize: 6, startDate: 'April 12, 2026', posted: '1 day ago', status: 'open', match: 36, matchReason: 'Cross-domain opportunity', instantMatch: false, hiredThisMonth: 5, referralBonus: 160 },
  { id: 405, title: 'Medical Terminology Annotation', rate: 50, domain: 'Linguistics', tier: 'Expert', client: 'Health NLP', duration: '5 weeks', teamSize: 4, startDate: 'April 6, 2026', posted: '6 days ago', status: 'closing_soon', match: 34, matchReason: 'Cross-domain opportunity', instantMatch: false, hiredThisMonth: 2, referralBonus: 240 },
  { id: 406, title: 'Hate Speech Detection Calibration', rate: 40, domain: 'Linguistics', tier: 'Standard', client: 'Content Safety Team', duration: '2 weeks', teamSize: 8, startDate: 'April 20, 2026', posted: '2 days ago', status: 'open', match: 37, matchReason: 'Cross-domain opportunity', instantMatch: false, hiredThisMonth: 16, referralBonus: 100 },

  // ===== MUSIC (6 jobs) =====
  { id: 501, title: 'Music Genre Classification at Scale', rate: 42, domain: 'Music', tier: 'Standard', client: 'Music Streaming Service', duration: '3 weeks', teamSize: 6, startDate: 'April 15, 2026', posted: '4 days ago', status: 'open', match: 55, matchReason: 'Audio-adjacent · Music domain', instantMatch: false, hiredThisMonth: 12, referralBonus: 120 },
  { id: 502, title: 'Instrument Separation Validation', rate: 46, domain: 'Music', tier: 'Advanced', client: 'AI Music Lab', duration: '2 weeks', teamSize: 4, startDate: 'April 12, 2026', posted: '1 day ago', status: 'open', match: 60, matchReason: 'Audio-adjacent · Advanced tier', instantMatch: false, hiredThisMonth: 3, referralBonus: 160 },
  { id: 503, title: 'Lyrics Transcription & Alignment', rate: 40, domain: 'Music', tier: 'Standard', client: 'Karaoke App', duration: '2 weeks', teamSize: 8, startDate: 'April 18, 2026', posted: '3 days ago', status: 'open', match: 52, matchReason: 'Audio-adjacent', instantMatch: false, hiredThisMonth: 20, referralBonus: 100 },
  { id: 504, title: 'Music Emotion & Mood Tagging', rate: 44, domain: 'Music', tier: 'Advanced', client: 'Playlist Intelligence', duration: '3 weeks', teamSize: 5, startDate: 'April 10, 2026', posted: '2 days ago', status: 'open', match: 58, matchReason: 'Audio-adjacent · Emotion analysis', instantMatch: false, hiredThisMonth: 7, referralBonus: 140 },
  { id: 505, title: 'Production Quality Assessment', rate: 50, domain: 'Music', tier: 'Expert', client: 'Mastering AI', duration: '4 weeks', teamSize: 4, startDate: 'April 8, 2026', posted: '5 days ago', status: 'closing_soon', match: 65, matchReason: 'Audio-adjacent opportunity', instantMatch: false, hiredThisMonth: 2, referralBonus: 220 },
  { id: 506, title: 'Beat Detection Ground Truth', rate: 38, domain: 'Music', tier: 'Standard', client: 'DJ Software Co.', duration: '1 week', teamSize: 6, startDate: 'April 22, 2026', posted: '1 day ago', status: 'open', match: 50, matchReason: 'Audio-adjacent', instantMatch: false, hiredThisMonth: 14, referralBonus: 80 },
];

// Rich detail content for each job — linked by job ID
export const jobDetailContent = {
  // ===== AUDIO =====
  1: {
    whatYouDo: ['Listen to raw audio clips (15-60 seconds) and identify individual Foley sound elements', 'Tag each sound event with start/end timestamps and category labels (footsteps, doors, fabric, etc.)', 'Rate the quality and realism of each Foley element on a 5-point scale', 'Flag clips with overlapping sounds that need manual review', 'Document edge cases where sound categories are ambiguous'],
    tools: 'Pipeline annotation platform (browser-based). Waveform viewer with spectrogram overlay. Keyboard shortcuts for rapid tagging.',
    qualityExpectations: 'Target accuracy: 95%+. All annotations undergo automated consistency checks and 15% are reviewed by senior annotators. Quality below 90% triggers a calibration session.',
    schedule: 'Flexible hours within project window. Recommended 3-4 hours/day for optimal throughput. Average annotation time: 2-3 minutes per clip.',
    sampleTask: 'Example: A 30-second clip of someone walking through a kitchen. Identify and timestamp: footsteps on tile (0:02-0:08), cabinet door opening (0:10-0:11), glass placed on counter (0:15-0:16), water running (0:18-0:25).',
    postedDate: 'March 30, 2026',
  },
  2: {
    whatYouDo: ['Classify ambient environmental audio recordings into scene categories (urban, rural, indoor, nature)', 'Identify and label dominant and secondary sound sources in each recording', 'Tag environmental context clues (time of day estimation, weather conditions, indoor/outdoor)', 'Annotate transitions between environments in continuous recordings', 'Document sound source rationale for ambiguous scenes'],
    tools: 'Pipeline annotation platform. Multi-channel audio player with loop and slow-down controls.',
    qualityExpectations: 'Target accuracy: 93%+. Scene classification reviewed by peer annotators. Inter-annotator agreement measured on 10% overlap.',
    schedule: 'Flexible. Estimated 2 minutes per recording. Recommended 2-3 hours/day.',
    sampleTask: 'Example: A 45-second recording. Primary: urban street (traffic, pedestrians). Secondary: construction noise (distant drilling). Context: daytime, outdoor, dry weather.',
    postedDate: 'March 27, 2026',
  },
  3: {
    whatYouDo: ['Transcribe target speech from recordings with significant background noise', 'Rate speech intelligibility on a 5-point scale per segment', 'Tag noise types present (babble, music, machinery, environmental)', 'Mark segments where speech is completely masked by noise', 'Annotate speaker turns and overlapping speech in multi-speaker recordings'],
    tools: 'Pipeline platform with noise-aware audio player. Adjustable noise gate and equalizer for playback assistance.',
    qualityExpectations: 'Target accuracy: 96%+. Expert-tier project with rigorous QA. 20% of annotations dual-reviewed.',
    schedule: '4-5 hours/day recommended. Complex annotations average 4-5 minutes per clip. 4-week commitment.',
    sampleTask: 'Example: Café recording with two speakers. Transcribe Speaker A over espresso machine noise. Rate intelligibility: 3/5. Noise type: babble + machinery.',
    postedDate: 'March 31, 2026',
  },
  101: {
    whatYouDo: ['Review machine-generated podcast transcriptions for accuracy', 'Correct misidentified words, timestamps, and speaker labels', 'Flag sections where audio quality prevents accurate transcription', 'Ensure proper punctuation and paragraph breaks match conversational flow'],
    tools: 'Pipeline platform with side-by-side audio/text editor. Auto-scroll playback synced to transcript.',
    qualityExpectations: 'Target word error rate: <3%. Random spot-checks on 20% of submissions.',
    schedule: 'Flexible. 15-20 minutes per podcast segment. 2-3 hours/day.',
    sampleTask: 'Example: Correct "their going to the store" → "they\'re going to the store". Fix timestamp drift on Speaker B after minute 12.',
    postedDate: 'March 29, 2026',
  },
  102: {
    whatYouDo: ['Label emotional valence and arousal in speech recordings across 8 emotion categories', 'Annotate emotion transitions within single utterances', 'Rate confidence level for each emotion label', 'Flag culturally ambiguous emotional expressions for review', 'Calibrate against gold-standard emotion labels during onboarding'],
    tools: 'Pipeline platform with emotion-specific annotation panel. Dimensional emotion wheel for valence/arousal mapping.',
    qualityExpectations: 'Target agreement: 85%+ with gold standard. Expert-tier precision required. Weekly calibration reviews.',
    schedule: '3-4 hours/day. Average 3 minutes per utterance. 5-week engagement.',
    sampleTask: 'Example: Speaker says "I can\'t believe you did that" with rising pitch. Label: surprise (0.8 confidence) transitioning to anger (0.6 confidence). Valence: negative. Arousal: high.',
    postedDate: 'March 31, 2026',
  },
  103: {
    whatYouDo: ['Detect and classify acoustic events in smart home environments', 'Timestamp event onset and offset with 100ms precision', 'Categorize events: alarms, glass breaking, appliance sounds, speech, pets, etc.', 'Label event urgency level (normal, attention, alert, emergency)'],
    tools: 'Pipeline platform with multi-room audio layout view. Event timeline editor.',
    qualityExpectations: 'Target accuracy: 94%+. Timestamp precision within 200ms. 15% dual-annotation for agreement.',
    schedule: 'Flexible. 2-3 minutes per event clip. 3 hours/day recommended.',
    sampleTask: 'Example: 20-second clip. Events: dog barking (0:02-0:05, normal), smoke alarm (0:08-0:18, emergency), door closing (0:19-0:20, normal).',
    postedDate: 'March 28, 2026',
  },
  104: {
    whatYouDo: ['Label segments of audio as music, speech, or mixed', 'Mark precise transition points between music and speech', 'Tag music segments with genre and energy level', 'Identify jingles, ads, and intro/outro music separately'],
    tools: 'Pipeline platform with waveform and spectrogram dual-view. Segment brush tool.',
    qualityExpectations: 'Target accuracy: 92%+. Boundary precision within 500ms.',
    schedule: 'Flexible. Fast-paced — 1-2 minutes per segment. 1-week sprint.',
    sampleTask: 'Example: Podcast clip. Speech (0:00-1:30), jingle transition (1:30-1:35), music bed under speech (1:35-3:00), pure speech (3:00-4:15).',
    postedDate: 'March 26, 2026',
  },
  105: {
    whatYouDo: ['Annotate 3D spatial position of sound sources in ambisonic recordings', 'Label azimuth, elevation, and distance for each identified source', 'Track moving sound sources across time with trajectory annotations', 'Validate spatial rendering accuracy for VR/AR audio scenes'],
    tools: 'Pipeline platform with 3D spatial audio visualizer. Head-tracking playback for immersive review.',
    qualityExpectations: 'Target spatial accuracy: ±10° azimuth, ±15° elevation. Expert-tier with peer review.',
    schedule: '3-4 hours/day. Complex annotations: 5-8 minutes per scene. 4-week commitment.',
    sampleTask: 'Example: Concert hall recording. Violin: azimuth 30°, elevation 5°, distance 8m, stationary. Audience cough: azimuth -45°, elevation -10°, distance 3m, single event.',
    postedDate: 'March 30, 2026',
  },

  // ===== VIDEO =====
  201: {
    whatYouDo: ['Label player actions in sports footage (running, jumping, kicking, throwing, etc.)', 'Draw bounding boxes around active players per frame', 'Track player identity across camera angle changes', 'Tag game events (goals, fouls, substitutions) with timestamps'],
    tools: 'Pipeline platform with frame-by-frame video player. Bounding box and keypoint tools.',
    qualityExpectations: 'Target accuracy: 93%+. Bounding box IoU > 0.8. Identity tracking consistency > 95%.',
    schedule: '3-4 hours/day. 5-8 minutes per clip. 3-week project.',
    sampleTask: 'Example: Soccer clip. Frame 120: Player #7 running (bbox: 340,200,420,580). Action: dribbling. Frame 145: Player #7 kicking (bbox: 360,190,440,570).',
    postedDate: 'March 31, 2026',
  },
  202: {
    whatYouDo: ['Annotate road scenes with semantic segmentation labels (vehicles, pedestrians, lanes, signs, obstacles)', 'Label 3D bounding boxes for vehicles and vulnerable road users', 'Tag weather and visibility conditions per sequence', 'Identify and flag safety-critical edge cases'],
    tools: 'Pipeline platform with point cloud + camera fusion viewer. 3D cuboid annotation tools.',
    qualityExpectations: 'Target mIoU: 92%+. Safety-critical classes (pedestrians, cyclists) require 97%+ recall. Expert-tier with double review.',
    schedule: '4-5 hours/day. 10-15 minutes per scene. 6-week commitment.',
    sampleTask: 'Example: Intersection scene. Segment: road surface, 3 vehicles (sedan, truck, bicycle), 2 pedestrians, traffic light (red), lane markings (dashed center, solid edge).',
    postedDate: 'March 28, 2026',
  },
  203: {
    whatYouDo: ['Identify highlight-worthy moments in long-form video content', 'Tag highlight type (emotional, action, funny, dramatic)', 'Rate highlight intensity on a 5-point scale', 'Mark optimal clip boundaries for social media excerpts'],
    tools: 'Pipeline platform with thumbnail scrubber and clip extraction tool.',
    qualityExpectations: 'Target agreement: 80%+ with editorial gold standard. Focus on recall — don\'t miss good moments.',
    schedule: 'Flexible. 5-10 minutes per 30-minute video. 2-week sprint.',
    sampleTask: 'Example: 45-minute interview. Highlight at 12:34-13:10: emotional story (intensity 4/5). Highlight at 28:45-29:02: funny moment (intensity 3/5).',
    postedDate: 'March 26, 2026',
  },
  204: {
    whatYouDo: ['Monitor surveillance footage for anomalous events', 'Classify anomaly types (intrusion, loitering, abandoned object, crowd formation)', 'Draw bounding regions around areas of interest', 'Log timeline of events with severity ratings'],
    tools: 'Pipeline platform with multi-camera grid view. Motion heatmap overlay.',
    qualityExpectations: 'Target detection rate: 95%+. False positive rate < 5%. Severity accuracy: 90%+.',
    schedule: '3-4 hours/day. Real-time speed review with pause-and-annotate. 4-week project.',
    sampleTask: 'Example: Parking lot camera. 14:32: Person loitering near vehicle (severity: medium). 14:38: Same person attempts door handle (severity: high).',
    postedDate: 'March 30, 2026',
  },
  205: {
    whatYouDo: ['Annotate hand and body gestures in video recordings', 'Label gesture type (pointing, waving, thumbs-up, sign language, etc.)', 'Track hand keypoints across frames', 'Classify gesture intent (communication, navigation, emotional expression)'],
    tools: 'Pipeline platform with hand keypoint skeleton overlay. Slow-motion playback.',
    qualityExpectations: 'Target keypoint accuracy: ±5px. Gesture classification: 90%+.',
    schedule: 'Flexible. 3-5 minutes per clip. 3-week project.',
    sampleTask: 'Example: Person giving presentation. Frame 45-60: pointing gesture (right hand, direction: screen-left). Frame 80-95: open palm gesture (both hands, intent: emphasis).',
    postedDate: 'March 31, 2026',
  },
  206: {
    whatYouDo: ['Review dashcam footage and classify incident types', 'Tag pre-incident, incident, and post-incident phases with timestamps', 'Rate incident severity (near-miss, minor, moderate, severe)', 'Identify contributing factors (weather, road condition, driver behavior)'],
    tools: 'Pipeline platform with GPS overlay and speed data. Incident classification panel.',
    qualityExpectations: 'Target accuracy: 92%+. Severity rating agreement: 85%+.',
    schedule: 'Flexible. 3-5 minutes per clip. Fast turnaround — 2-week sprint.',
    sampleTask: 'Example: Highway clip. Pre-incident (0:00-0:08): heavy traffic, rain. Incident (0:08-0:12): vehicle ahead brakes suddenly, near-miss. Severity: moderate. Factor: wet road + tailgating.',
    postedDate: 'March 29, 2026',
  },
  207: {
    whatYouDo: ['Analyze film sequences for shot composition elements', 'Label camera movements (pan, tilt, dolly, zoom, steadicam, handheld)', 'Tag shot types (close-up, medium, wide, establishing, POV)', 'Annotate lighting style, color palette, and depth of field'],
    tools: 'Pipeline platform with frame-by-frame analysis view. Color histogram and composition grid overlay.',
    qualityExpectations: 'Target accuracy: 90%+. Expert-tier — requires film/cinematography knowledge.',
    schedule: '3-4 hours/day. 8-12 minutes per sequence. 5-week engagement.',
    sampleTask: 'Example: 20-second sequence. Shot 1 (0:00-0:04): Wide establishing, static camera, natural lighting, warm palette. Shot 2 (0:04-0:09): Medium close-up, dolly-in, shallow DOF, key light from left.',
    postedDate: 'March 31, 2026',
  },

  // ===== VISUAL =====
  301: {
    whatYouDo: ['Segment medical images (X-rays, CT scans, MRIs) into anatomical regions', 'Label pathological findings with classification codes', 'Trace organ boundaries with pixel-level precision', 'Flag images with insufficient quality for annotation'],
    tools: 'Pipeline platform with medical imaging viewer (DICOM support). Polygon and brush segmentation tools.',
    qualityExpectations: 'Target Dice score: 0.92+. Expert-tier with radiologist review. HIPAA-compliant workflow.',
    schedule: '4-5 hours/day. 10-20 minutes per image depending on complexity. 4-week commitment.',
    sampleTask: 'Example: Chest X-ray. Segment: left lung, right lung, heart silhouette, mediastinum. Flag: small opacity in right lower lobe (potential finding).',
    postedDate: 'March 30, 2026',
  },
  302: {
    whatYouDo: ['Tag product images with category, color, pattern, and material attributes', 'Verify auto-generated product tags for accuracy', 'Flag images with incorrect or misleading product representation', 'Apply standardized taxonomy across product categories'],
    tools: 'Pipeline platform with product taxonomy browser. Batch tagging interface for high throughput.',
    qualityExpectations: 'Target accuracy: 94%+. High volume — throughput matters alongside quality.',
    schedule: 'Flexible. Fast-paced — 30-60 seconds per product. 2-week sprint.',
    sampleTask: 'Example: Blue denim jacket. Tags: category=outerwear, subcategory=jacket, material=denim, color=indigo, pattern=solid, fit=relaxed.',
    postedDate: 'March 29, 2026',
  },
  303: {
    whatYouDo: ['Classify satellite imagery patches by land use type', 'Draw polygon boundaries around distinct geographic features', 'Label temporal changes between multi-date imagery pairs', 'Identify and classify man-made structures vs natural features'],
    tools: 'Pipeline platform with geospatial viewer. Multi-spectral band switching. Polygon drawing tools.',
    qualityExpectations: 'Target classification: 91%+. Polygon boundary IoU: 0.85+.',
    schedule: '3-4 hours/day. 5-8 minutes per image tile. 3-week project.',
    sampleTask: 'Example: 500x500m tile. Features: residential area (polygon A), agricultural field (polygon B), water body (polygon C), road network (polyline D).',
    postedDate: 'March 31, 2026',
  },
  304: {
    whatYouDo: ['Verify and correct AI-detected facial landmarks (68/98 point models)', 'Annotate landmarks on challenging faces (occlusion, extreme angles, makeup)', 'Label face attributes (expression, gaze direction, head pose)', 'Flag synthetic or heavily filtered images'],
    tools: 'Pipeline platform with landmark point editor. Zoom and contrast adjustment tools.',
    qualityExpectations: 'Target landmark accuracy: ±2px normalized. Attribute accuracy: 93%+.',
    schedule: 'Flexible. 2-3 minutes per face. 2-week sprint.',
    sampleTask: 'Example: Face with sunglasses. Adjust occluded eye landmarks to estimated positions. Label: expression=neutral, gaze=forward (estimated), head_pose=slight_left_turn.',
    postedDate: 'March 27, 2026',
  },
  305: {
    whatYouDo: ['Annotate document layouts by identifying text blocks, headers, tables, figures, and captions', 'Draw bounding boxes around each layout element', 'Label reading order for multi-column documents', 'Classify document type (invoice, report, article, form, letter)'],
    tools: 'Pipeline platform with document viewer. Rectangle annotation with auto-snap to text boundaries.',
    qualityExpectations: 'Target accuracy: 93%+. Reading order: 95%+ sequential accuracy.',
    schedule: 'Flexible. 3-5 minutes per page. 3-week project.',
    sampleTask: 'Example: Research paper page. Elements: title (box 1), author block (box 2), abstract (box 3), two-column body text (boxes 4-5), figure with caption (box 6). Reading order: 1→2→3→4→5→6.',
    postedDate: 'March 30, 2026',
  },
  306: {
    whatYouDo: ['Inspect product images for manufacturing defects (scratches, dents, discoloration, misalignment)', 'Classify defect severity (cosmetic, functional, critical)', 'Draw pixel-level masks around defect regions', 'Rate overall product quality on a pass/fail scale'],
    tools: 'Pipeline platform with high-resolution zoom viewer. Brush and polygon mask tools. Defect taxonomy panel.',
    qualityExpectations: 'Target detection: 97%+ recall for critical defects. Expert-tier with quality engineer review.',
    schedule: '4-5 hours/day. 3-5 minutes per image. 6-week commitment.',
    sampleTask: 'Example: Metal component image. Defect 1: surface scratch (5mm, cosmetic, mask area A). Defect 2: edge chip (2mm, functional, mask area B). Overall: fail.',
    postedDate: 'March 28, 2026',
  },
  307: {
    whatYouDo: ['Classify wildlife species captured by camera traps', 'Count individuals per image where possible', 'Tag behavior (feeding, moving, resting, alert)', 'Label environmental conditions (day/night, weather, vegetation density)'],
    tools: 'Pipeline platform with batch classification interface. Species reference guide integrated.',
    qualityExpectations: 'Target species accuracy: 92%+. Count accuracy: ±1 individual.',
    schedule: 'Flexible. Fast-paced — 30-60 seconds per image. 2-week sprint.',
    sampleTask: 'Example: Night camera trap image. Species: white-tailed deer. Count: 2 (adult + fawn). Behavior: feeding. Conditions: night, infrared, forest edge.',
    postedDate: 'March 31, 2026',
  },

  // ===== LINGUISTICS =====
  401: {
    whatYouDo: ['Classify sentiment in text samples across multiple languages', 'Label sentiment polarity (positive, negative, neutral, mixed) with confidence scores', 'Identify sentiment targets (what the sentiment is about)', 'Flag sarcasm, irony, and culturally-specific expressions'],
    tools: 'Pipeline platform with multilingual text viewer. Side-by-side translation reference. Sentiment scale slider.',
    qualityExpectations: 'Target accuracy: 90%+. Sarcasm detection: 80%+. Inter-annotator agreement: 85%+.',
    schedule: '3-4 hours/day. 1-2 minutes per text sample. 3-week project.',
    sampleTask: 'Example: Product review in Spanish: "El diseño es bonito pero se rompió al segundo día." Sentiment: mixed. Target: design (positive), durability (negative). Sarcasm: no.',
    postedDate: 'March 30, 2026',
  },
  402: {
    whatYouDo: ['Extract named entities from legal documents (parties, dates, amounts, clauses)', 'Classify entity relationships (plaintiff-defendant, contract parties, obligations)', 'Label contractual provisions with standardized legal taxonomy', 'Flag ambiguous or conflicting terms for legal review'],
    tools: 'Pipeline platform with legal document viewer. Entity highlighting and relationship mapping tools.',
    qualityExpectations: 'Target entity extraction: 95%+. Expert-tier — requires legal domain knowledge. Dual annotation on all documents.',
    schedule: '3-4 hours/day. 15-20 minutes per document. 4-week commitment.',
    sampleTask: 'Example: Contract clause. Extract: Party A (Acme Corp), Party B (Beta Inc), effective date (Jan 1, 2026), payment amount ($50,000/month). Relationship: service agreement.',
    postedDate: 'March 27, 2026',
  },
  403: {
    whatYouDo: ['Rate AI chatbot responses for helpfulness, accuracy, and safety', 'Write improved alternative responses where the AI falls short', 'Classify conversation intent and topic shifts', 'Flag responses containing hallucinations or harmful content'],
    tools: 'Pipeline platform with conversation thread viewer. Side-by-side comparison for A/B response ranking.',
    qualityExpectations: 'Target rating consistency: 85%+ agreement with gold standard. Response quality: coherent, factual, safe.',
    schedule: 'Flexible. 2-4 minutes per conversation turn. High volume available.',
    sampleTask: 'Example: User asks "What\'s the capital of Australia?" AI responds "Sydney." Rate: accuracy 1/5 (incorrect, should be Canberra). Write correction. Flag: factual error.',
    postedDate: 'March 29, 2026',
  },
  404: {
    whatYouDo: ['Identify and label code-switching points in Hindi-English text and audio', 'Classify switch type (inter-sentential, intra-sentential, tag-switching)', 'Annotate language ID at word and phrase level', 'Label sociolinguistic triggers for code-switching (topic, formality, emphasis)'],
    tools: 'Pipeline platform with bilingual text/audio viewer. Word-level language tagging interface.',
    qualityExpectations: 'Target accuracy: 92%+. Requires native-level Hindi-English bilingual proficiency.',
    schedule: '3-4 hours/day. 3-5 minutes per sample. 3-week project.',
    sampleTask: 'Example: "Meeting ke baad let\'s grab coffee." Language labels: Meeting(EN) ke(HI) baad(HI) let\'s(EN) grab(EN) coffee(EN). Switch type: intra-sentential. Trigger: topic shift.',
    postedDate: 'March 31, 2026',
  },
  405: {
    whatYouDo: ['Annotate medical text with standardized terminology codes (ICD-10, SNOMED)', 'Label medical entities (symptoms, diagnoses, medications, procedures)', 'Map lay language to clinical terminology', 'Flag potential PHI (protected health information) for de-identification'],
    tools: 'Pipeline platform with medical ontology browser. Auto-suggest for terminology codes. PHI detection overlay.',
    qualityExpectations: 'Target accuracy: 95%+. Expert-tier — requires medical terminology knowledge. HIPAA-compliant workflow.',
    schedule: '3-4 hours/day. 10-15 minutes per clinical note. 5-week commitment.',
    sampleTask: 'Example: "Patient presents with chest pain and shortness of breath." Entities: chest pain (R07.9), shortness of breath (R06.02). Category: symptoms. PHI check: none detected.',
    postedDate: 'March 26, 2026',
  },
  406: {
    whatYouDo: ['Review and calibrate AI hate speech detection model outputs', 'Label content severity (benign, borderline, harmful, dangerous)', 'Classify hate speech targets (race, gender, religion, nationality, etc.)', 'Write rationale for each classification decision'],
    tools: 'Pipeline platform with content review interface. Guideline reference panel. Severity scale with examples.',
    qualityExpectations: 'Target accuracy: 90%+. Requires consistent application of content policy. Weekly calibration sessions.',
    schedule: 'Flexible with mental health breaks encouraged. 2-3 minutes per item. Content warning: exposure to harmful content.',
    sampleTask: 'Example: Social media comment. Classification: borderline (implicit bias). Target category: nationality. Rationale: Uses coded language that implies negative stereotype without explicit slurs.',
    postedDate: 'March 30, 2026',
  },

  // ===== MUSIC =====
  501: {
    whatYouDo: ['Classify music tracks into primary and secondary genres', 'Tag sub-genre characteristics (tempo range, instrumentation, vocal style)', 'Rate genre confidence and flag genre-ambiguous tracks', 'Apply hierarchical taxonomy (e.g., Electronic > House > Deep House)'],
    tools: 'Pipeline platform with 30-second preview player. Genre taxonomy tree navigator. Multi-label tagging interface.',
    qualityExpectations: 'Target primary genre accuracy: 90%+. Sub-genre: 80%+. High volume — 30-60 seconds per track.',
    schedule: 'Flexible. Fast-paced. 2-3 hours/day. 3-week project.',
    sampleTask: 'Example: Track preview. Primary: Hip-Hop. Secondary: R&B. Sub-genre: Trap. Characteristics: 140 BPM, heavy 808s, auto-tuned vocals. Confidence: high.',
    postedDate: 'March 28, 2026',
  },
  502: {
    whatYouDo: ['Validate AI-generated instrument separation (stems) for accuracy', 'Rate isolation quality per instrument (vocals, drums, bass, other)', 'Identify artifacts (bleeding, phase issues, missing frequencies)', 'Compare separated stems against original mix for fidelity'],
    tools: 'Pipeline platform with multi-track player. A/B toggle between separated and original. Spectrogram view per stem.',
    qualityExpectations: 'Target artifact detection: 95%+. Quality rating consistency: 85%+ with reference annotations.',
    schedule: '3-4 hours/day. 5-8 minutes per track. 2-week sprint.',
    sampleTask: 'Example: Pop track separated into 4 stems. Vocals: quality 4/5 (slight reverb bleed from guitar). Drums: quality 5/5 (clean). Bass: quality 3/5 (missing sub frequencies below 60Hz). Other: quality 4/5.',
    postedDate: 'March 31, 2026',
  },
  503: {
    whatYouDo: ['Transcribe song lyrics from audio with precise word-level timing', 'Align lyrics to audio at word and syllable level', 'Handle backing vocals, ad-libs, and harmonies separately', 'Flag explicit content and non-English sections'],
    tools: 'Pipeline platform with synchronized lyrics editor. Waveform with word-snap alignment tool.',
    qualityExpectations: 'Target transcription accuracy: 95%+. Alignment precision: ±50ms per word.',
    schedule: 'Flexible. 8-15 minutes per song. 2-week project.',
    sampleTask: 'Example: First verse alignment. "Hello" starts at 0:05.230, ends 0:05.890. "It\'s" starts 0:05.920, ends 0:06.100. "me" starts 0:06.120, ends 0:06.580.',
    postedDate: 'March 29, 2026',
  },
  504: {
    whatYouDo: ['Tag music tracks with emotion and mood labels from standardized vocabulary', 'Rate energy level and emotional valence on continuous scales', 'Identify mood shifts within tracks and timestamp transitions', 'Label contextual use cases (workout, relaxation, study, party, etc.)'],
    tools: 'Pipeline platform with mood wheel interface. Continuous valence-arousal slider. Context tag panel.',
    qualityExpectations: 'Target agreement: 80%+ with peer annotators. Mood transitions accurately timestamped within 2 seconds.',
    schedule: '3-4 hours/day. 3-5 minutes per track. 3-week project.',
    sampleTask: 'Example: Indie folk track. Primary mood: melancholic. Energy: 3/10. Valence: -0.4. Transition at 2:15: mood shifts to hopeful (energy rises to 5/10). Use case: reflective/evening.',
    postedDate: 'March 30, 2026',
  },
  505: {
    whatYouDo: ['Evaluate production quality of mastered audio tracks', 'Rate technical aspects: dynamic range, stereo imaging, frequency balance, loudness', 'Compare against reference tracks in the same genre', 'Identify production issues (clipping, excessive compression, phase problems, muddy mix)'],
    tools: 'Pipeline platform with mastering-grade audio player. Loudness meter, stereo analyzer, and spectrum analyzer.',
    qualityExpectations: 'Target accuracy: 90%+. Expert-tier — requires professional audio production experience. Peer-reviewed.',
    schedule: '3-4 hours/day. 8-12 minutes per track. 4-week commitment.',
    sampleTask: 'Example: EDM track. Dynamic range: 6dB (compressed). Stereo width: wide (good). Low-end: muddy below 100Hz (issue). Loudness: -7 LUFS (appropriate for genre). Overall: 3.5/5.',
    postedDate: 'March 27, 2026',
  },
  506: {
    whatYouDo: ['Annotate beat positions in music tracks with sub-millisecond precision', 'Label downbeats, upbeats, and measure boundaries', 'Tag tempo changes and rubato sections', 'Classify time signature and rhythmic feel (straight, swing, shuffle)'],
    tools: 'Pipeline platform with beat-grid editor. Tap-tempo tool. Metronome overlay for verification.',
    qualityExpectations: 'Target beat accuracy: ±20ms. Downbeat accuracy: ±10ms. Tempo estimation: ±1 BPM.',
    schedule: 'Flexible. 5-8 minutes per track. Fast 1-week sprint.',
    sampleTask: 'Example: Funk track. Tempo: 108 BPM. Time signature: 4/4. Feel: straight with slight swing on hi-hats. Downbeats at: 0:00.000, 0:02.222, 0:04.444...',
    postedDate: 'March 31, 2026',
  },
};

// Enrich jobs with rateRange and detail content
export const allJobs = allJobsRaw.map(job => ({
  ...job,
  rateRange: RATE_RANGES[job.tier] || { min: job.rate, max: job.rate },
  details: jobDetailContent[job.id] || null,
}));

// Applications data
export const myApplications = [
  {
    id: 'app-1',
    jobId: 3,
    jobTitle: 'Speech-in-Noise Annotation',
    domain: 'Audio',
    tier: 'Expert',
    rate: 48,
    appliedDate: 'Mar 30, 2026',
    stage: 'assessment',
    stageLabel: 'Assessment',
    estimatedResponse: '1-2 days',
    client: 'Enterprise Voice AI',
  },
  {
    id: 'app-2',
    jobId: 1,
    jobTitle: 'Foley & Environmental Audio',
    domain: 'Audio',
    tier: 'Advanced',
    rate: 46,
    appliedDate: 'Mar 28, 2026',
    stage: 'accepted',
    stageLabel: 'Accepted',
    estimatedResponse: null,
    client: 'Confidential — Major Studio',
  },
  {
    id: 'app-3',
    jobId: 501,
    jobTitle: 'Music Genre Classification at Scale',
    domain: 'Music',
    tier: 'Standard',
    rate: 42,
    appliedDate: 'Mar 25, 2026',
    stage: 'not_selected',
    stageLabel: 'Not Selected',
    estimatedResponse: null,
    reason: 'Position filled with Music domain specialists',
    client: 'Music Streaming Service',
  },
  {
    id: 'app-4',
    jobId: 101,
    jobTitle: 'Podcast Transcription QA',
    domain: 'Audio',
    tier: 'Standard',
    rate: 40,
    appliedDate: 'Mar 22, 2026',
    stage: 'under_review',
    stageLabel: 'Under Review',
    estimatedResponse: '2-3 days',
    client: 'Media Startup',
  },
];

// Payment/earnings data
export const earningsOverview = {
  thisPeriod: {
    total: 2847.60,
    base: 2460.00,
    bonuses: 300.00,
    boostedHours: 87.60,
    periodStart: 'Mar 17, 2026',
    periodEnd: 'Mar 30, 2026',
  },
  nextPayout: {
    amount: 2847.60,
    date: 'Apr 4, 2026',
    method: 'Stripe Connect',
    accountLast4: '4242',
  },
  lifetime: {
    total: 18420.80,
    bonuses: 1650.00,
    boostedHours: 520.60,
    hoursWorked: 412,
    jobsCompleted: 7,
  },
  weeklyTrend: [1620, 1890, 2100, 1950, 2340, 2580, 2847],
};

export const transactions = [
  {
    id: 'tx-1',
    date: 'Mar 28, 2026',
    job: 'Foley & Environmental Audio',
    hours: 6.5,
    baseRate: 46,
    boostApplied: true,
    boostRate: 50.60,
    total: 328.90,
    status: 'pending',
  },
  {
    id: 'tx-2',
    date: 'Mar 27, 2026',
    job: 'Foley & Environmental Audio',
    hours: 5.0,
    baseRate: 46,
    boostApplied: true,
    boostRate: 50.60,
    total: 253.00,
    status: 'pending',
  },
  {
    id: 'tx-3',
    date: 'Mar 26, 2026',
    job: 'Foley & Environmental Audio',
    hours: 7.0,
    baseRate: 46,
    boostApplied: false,
    boostRate: null,
    total: 322.00,
    status: 'pending',
  },
  {
    id: 'tx-4',
    date: 'Mar 25, 2026',
    job: 'Foley & Environmental Audio',
    hours: 4.5,
    baseRate: 46,
    boostApplied: false,
    boostRate: null,
    total: 207.00,
    status: 'pending',
  },
  {
    id: 'tx-5',
    date: 'Mar 24, 2026',
    description: 'Sprint Bonus — Craft Sprint Week 11',
    hours: null,
    baseRate: null,
    boostApplied: false,
    boostRate: null,
    total: 150.00,
    status: 'paid',
    type: 'bonus',
  },
  {
    id: 'tx-6',
    date: 'Mar 21, 2026',
    job: 'Studio Dialogue Cleanup',
    hours: 6.0,
    baseRate: 44,
    boostApplied: false,
    boostRate: null,
    total: 264.00,
    status: 'paid',
  },
  {
    id: 'tx-7',
    date: 'Mar 20, 2026',
    job: 'Studio Dialogue Cleanup',
    hours: 5.5,
    baseRate: 44,
    boostApplied: false,
    boostRate: null,
    total: 242.00,
    status: 'paid',
  },
  {
    id: 'tx-8',
    date: 'Mar 19, 2026',
    job: 'Studio Dialogue Cleanup',
    hours: 7.0,
    baseRate: 44,
    boostApplied: false,
    boostRate: null,
    total: 308.00,
    status: 'paid',
  },
  {
    id: 'tx-9',
    date: 'Mar 14, 2026',
    description: 'Facilitator Bonus — Craft Sprint Week 10',
    hours: null,
    baseRate: null,
    boostApplied: false,
    boostRate: null,
    total: 75.00,
    status: 'paid',
    type: 'bonus',
  },
  {
    id: 'tx-10',
    date: 'Mar 10, 2026',
    description: 'Sprint Bonus — Knowledge Sprint Week 9',
    hours: null,
    baseRate: null,
    boostApplied: false,
    boostRate: null,
    total: 150.00,
    status: 'paid',
    type: 'bonus',
  },
];

// Assessments data
export const assessments = [
  // Completed
  {
    id: 'assess-1',
    name: 'Audio Domain Assessment',
    domain: 'Audio',
    type: 'domain',
    status: 'passed',
    score: 94,
    dateTaken: 'Jan 15, 2026',
    expiresAt: 'Jan 15, 2027',
    duration: '25 min',
    attempts: 1,
    maxAttempts: 3,
    description: 'Tests core audio annotation competency — waveform reading, spectral analysis, sound event classification, foley identification, and spatial audio concepts.',
    format: '40 multiple choice + 5 practical annotation tasks',
    unlocks: 8,
    unlocksLabel: '8 Audio jobs currently available',
  },
  {
    id: 'assess-2',
    name: 'Skills Evaluation — Audio',
    domain: 'Audio',
    type: 'skills',
    status: 'passed',
    score: 97,
    dateTaken: 'Jan 18, 2026',
    expiresAt: 'Jul 18, 2026',
    duration: '45 min',
    attempts: 1,
    maxAttempts: 3,
    description: 'Practical annotation task graded for precision, consistency, and edge case handling. Annotate a set of 20 audio clips across foley, speech, and environmental categories.',
    format: 'Practical annotation task — 20 clips, timed',
    unlocks: 5,
    unlocksLabel: '5 Advanced/Expert Audio jobs',
  },
  {
    id: 'assess-3',
    name: 'Work Authorization',
    domain: null,
    type: 'compliance',
    status: 'passed',
    score: null,
    dateTaken: 'Jan 10, 2026',
    expiresAt: null,
    duration: '5 min',
    attempts: 1,
    maxAttempts: 1,
    description: 'Verify your eligibility to work as an independent contractor. One-time verification.',
    format: 'Document upload + self-declaration',
    unlocks: null,
    unlocksLabel: 'Required for all jobs',
  },
  // Available but not taken
  {
    id: 'assess-4',
    name: 'Music Domain Assessment',
    domain: 'Music',
    type: 'domain',
    status: 'available',
    score: null,
    dateTaken: null,
    expiresAt: null,
    duration: '25 min',
    attempts: 0,
    maxAttempts: 3,
    description: 'Tests music annotation competency — genre classification, beat detection, instrument identification, harmonic analysis, and production quality assessment.',
    format: '35 multiple choice + 5 practical annotation tasks',
    unlocks: 6,
    unlocksLabel: '6 Music jobs currently available',
  },
  {
    id: 'assess-5',
    name: 'Video Domain Assessment',
    domain: 'Video',
    type: 'domain',
    status: 'available',
    score: null,
    dateTaken: null,
    expiresAt: null,
    duration: '30 min',
    attempts: 0,
    maxAttempts: 3,
    description: 'Tests video annotation competency — temporal segmentation, action recognition, object tracking, scene classification, and shot composition analysis.',
    format: '35 multiple choice + 5 practical annotation tasks',
    unlocks: 7,
    unlocksLabel: '7 Video jobs currently available',
  },
  {
    id: 'assess-6',
    name: 'Visual Domain Assessment',
    domain: 'Visual',
    type: 'domain',
    status: 'available',
    score: null,
    dateTaken: null,
    expiresAt: null,
    duration: '30 min',
    attempts: 0,
    maxAttempts: 3,
    description: 'Tests visual annotation competency — image segmentation, bounding box precision, object classification, depth estimation, and visual relationship annotation.',
    format: '35 multiple choice + 5 practical annotation tasks',
    unlocks: 7,
    unlocksLabel: '7 Visual jobs currently available',
  },
  {
    id: 'assess-7',
    name: 'Linguistics Domain Assessment',
    domain: 'Linguistics',
    type: 'domain',
    status: 'available',
    score: null,
    dateTaken: null,
    expiresAt: null,
    duration: '30 min',
    attempts: 0,
    maxAttempts: 3,
    description: 'Tests linguistics annotation competency — named entity recognition, sentiment analysis, syntactic parsing, code-switching detection, and discourse analysis.',
    format: '35 multiple choice + 5 practical annotation tasks',
    unlocks: 6,
    unlocksLabel: '6 Linguistics jobs currently available',
  },
  {
    id: 'assess-8',
    name: 'Skills Evaluation — Music',
    domain: 'Music',
    type: 'skills',
    status: 'available',
    score: null,
    dateTaken: null,
    expiresAt: null,
    duration: '45 min',
    attempts: 0,
    maxAttempts: 3,
    description: 'Practical music annotation task — classify genres, detect beats, identify instruments, and assess production quality across 15 tracks.',
    format: 'Practical annotation task — 15 tracks, timed',
    unlocks: 3,
    unlocksLabel: '3 Advanced/Expert Music jobs',
  },
];

// Stage config for My Applications
export const stageConfig = {
  applied: { label: 'Applied', color: 'var(--text-muted)', order: 0 },
  under_review: { label: 'Under Review', color: 'var(--accent-blue)', order: 1 },
  assessment: { label: 'Trial Task', color: 'var(--accent-gold)', order: 2 },
  skills_evaluation: { label: 'Trial Task', color: 'var(--accent-purple)', order: 2.5 },
  accepted: { label: 'Accepted', color: 'var(--accent-teal)', order: 3 },
  started: { label: 'Started', color: '#5dcaa5', order: 4 },
  active: { label: 'Active', color: 'var(--accent-teal)', order: 4 },
  not_selected: { label: 'Not Selected', color: 'var(--text-muted)', order: 5 },
  withdrawn: { label: 'Withdrawn', color: 'var(--text-tertiary)', order: 6 },
};
